import React, { useState } from "react";
import apiClient from "../services/apiClient";
import { useTranslation } from 'react-i18next';

const SearchBar = ({ onSearch }) => {
  const [query, setQuery] = useState("");
  const { t } = useTranslation();

  const handleSearch = () => {
    // Gọi API tìm kiếm
    apiClient.get(`/api/v1/search?q=${query}`)
      .then((response) => onSearch(response.data)) // Trả kết quả về component cha
      .catch((error) => console.error("Error searching stories:", error));
  };

  return (
    <div className="mb-4">
      <input
        type="text"
        placeholder={t('searchForStories')}
        className="border p-2 rounded w-80"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      <button
        onClick={handleSearch}
        className="ml-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
      >
        {t('search')}
      </button>
    </div>
  );
};

export default SearchBar;